import { supabase } from '../utils/supabase';

/**
 * Kick off deferred session-completion side effects (snapshots, activity moments).
 * Fire-and-forget — session end UX must not wait for these.
 */
export const triggerSessionCompletionEffects = (sessionId) => {
  if (!sessionId) return;

  supabase.functions
    .invoke('process-session-completion', { body: { sessionId } })
    .then(({ error }) => {
      if (error) {
        console.warn('[SESSION] Deferred completion effects failed to start:', error);
      }
    })
    .catch((err) => {
      console.warn('[SESSION] Deferred completion effects invoke error:', err);
    });
};
